import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { traderAPI } from '../lib/api';
import { formatTraderDate, Timestamp, timezoneLabel, traderInputToUTC } from '../lib/traderTime';

const TraderTimeContext = createContext({ offsetMinutes: 0, setOffsetMinutes: (_value: number) => {} });

export const TraderTimeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [offsetMinutes, setOffsetMinutes] = useState(0);
    const [ready, setReady] = useState(false);
    const [error, setError] = useState(false);
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        let active = true;
        setError(false);
        traderAPI.getSettings().then(settings => {
            if (!active) return;
            setOffsetMinutes(settings.timezone_offset_minutes ?? 0);
            setReady(true);
        }).catch(() => { if (active) setError(true); });
        return () => { active = false; };
    }, [attempt]);
    const value = useMemo(() => ({ offsetMinutes, setOffsetMinutes }), [offsetMinutes]);
    if (!ready) return <div className="p-8" role="status">{error
        ? <>Не удалось загрузить часовой пояс. <button onClick={() => setAttempt(n => n + 1)}>Повторить</button></>
        : 'Загрузка настроек…'}</div>;
    return <TraderTimeContext.Provider value={value}>{children}</TraderTimeContext.Provider>;
};

export function useTraderTime() {
    const { offsetMinutes, setOffsetMinutes } = useContext(TraderTimeContext);
    return useMemo(() => ({
        offsetMinutes, setOffsetMinutes,
        label: timezoneLabel(offsetMinutes),
        formatDate: (value: Timestamp | null | undefined) => formatTraderDate(value, offsetMinutes),
        inputToUTC: (value: string) => traderInputToUTC(value, offsetMinutes),
    }), [offsetMinutes, setOffsetMinutes]);
}
